import { configureStore } from '@reduxjs/toolkit'
import { load, save } from 'redux-localstorage-simple'

import application from './application/reducer'
import { updateVersion } from './global/actions'
import search from './search/reducer'
import transactions from './transactions/reducer'

const PERSISTED_KEYS: string[] = ['transactions', 'lists', 'search']

// slices that no longer exist; drop their persisted entries
const STALE_PERSISTED_KEYS = ['authentication', 'user', 'shoppingCart']
STALE_PERSISTED_KEYS.forEach((key) => {
  try {
    localStorage.removeItem(`redux_localstorage_simple_${key}`)
  } catch (e) {
    console.error('Unable to remove stale persisted state', e)
  }
})

const store = configureStore({
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ serializableCheck: false, thunk: false }),
    save({ states: PERSISTED_KEYS })
  ],
  preloadedState: load({ states: PERSISTED_KEYS }),
  reducer: {
    application,
    search,
    transactions
  }
})

store.dispatch(updateVersion())

export default store

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
